export const hashRoutes = {
  SETTINGS: '#app-setting',
  LEADER_BOARD: '#leader-board',
};

const routes = {
  NOT_SUPPORTED: '/not-supported',
  HOME: '/',
  GAME: '/game',
  PRIVACY_POLICY: '/privacy-policy',
  NATIVE_CHART: '/native-chart',
  DEMO_TRADE: '/trade',
  ABOUT_US: '/about-us',
  CONTACT_US: '/contact-us',
  FAQ: '/faqs',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  NOT_FOUND: '*',
  TRADE_HISTORY: '/trade-history',
  VERIFY_EMAIL: '/verify-email/:id/:code',
  OTP_VERIFY: '/otp-verify',
  WITHDRAW: '/withdraw',
  CHART: { ROOT: '/trade/*', HOME: '/trade' },
  ASSETS_MARKET: '/assets-market',
  PROFILE: {
    ROOT: '/profile/*',
    HOME: '/profile/',
    ACCOUNT: 'account',
    DEPOSIT: 'deposit',
    TRANSFER: 'deposit/:transferId',
    TRANSFER_HOME: 'transfer/',
    PERFECT_MONEY: 'perfect-money',
    MASTER_CARD: 'master-card',
    UPI_CARD: 'upi-card',
    TRANSACTION: 'transaction',
    WITHDRAWAL: 'withdrawal',
    TRADES: 'trades',
    MY_ASSETS: 'my-assets',
    MY_LISTING: 'my-listing',
    DASHBOARD: 'dashboard',
  },
  SUPPORT: {
    ROOT: '/support/*',
    HOME: '/support/',
    MY_REQUEST: 'my-request',
    FAQ: 'faq',
    ADD_REQUEST: 'add-request',
    SUPPORT_DETAIL: '/support/:requestId',
  },
  UNDER_MAINTENANCE: '/under-maintenance',
  LAUNCHING_SOON: '/launching-soon',
};

export default routes;
